// removed by extract-text-webpack-plugin
module.exports = {"scrollableList":"scrollableList___1HHnG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollableList/index.scss
// module id = 105
// module chunks = 0